<template>
    <div>
    <div class="popup__header">
        <div class="title">Итоги сверхурочной работы </div>
    </div>


    <div class="popup__content">
        <div class="mt40 timer-stoped" v-if="user.workOvertimeNoComment.date">
            Таймер сверхурочной отработки был остановлен автоматически {{user.workOvertimeNoComment.date}}. <br>
            Длительность отработки {{user.workOvertimeNoComment.time}}
        </div>
        <div class="mb40 mt40">
            <textarea-field :class="'full'"
                            v-model="form.text.value"
                            :error-text="''"
                            :label="'Напишите итоги отработанного времени'"
                            :is-error="form.text.error"
                            @focus="form.text.error = false"
                            :add-style="{minHeight: 168 + 'px'}"></textarea-field>
        </div>
        <div class="df df-space-between mt40">
            <submit-btn @click="send" tag="button" :type="btnType">
                отправить
            </submit-btn>
        </div>
    </div>
</div>
</template>

<script>
    import Tooltip from '@/components/Tooltip.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import TextareaField from '@/components/forms/TextareaField.vue';
    import {mapState} from "vuex";

    export default {
        name: "workOvertime",
        components: {
            Tooltip,
            SubmitBtn,
            TextareaField
        },
        props: {

        },
        watch: {

        },
        data: function () {
            return {
                btnType: 'normal',
                form: {
                    text: {
                        value: '',
                        error: false,
                        repeatError: false,
                    },
                }
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                options: state => state.options,
                user: state => state.auth.user,
                menuList: state => state.menus.itemsTop,
            }),
            activeMenuItem() {
                let item = {};
                let id = '';
                if (this.$route.params.id) {
                    id = this.$route.params.id;
                }

                if (!id && Object.values(this.menuList)[0]) {
                    for(let m in this.menuList){
                        if(this.user.id == this.menuList[m].userId){
                            item = this.menuList[m];
                        }
                    }
                } else {
                    for(let m in this.menuList){
                        if(id == this.menuList[m].id){
                            item = this.menuList[m];
                        }
                    }
                }

                return item;
            },
        },
        mounted: function () {

        },
        emits: ['update:modelValue', 'calendarshow'],
        methods: {
            send(){
                let error = false;
                for(let field in this.form){
                    let errorField = false;
                    this.form[field].error = false;

                    if(field == 'text' && this.form[field].value.length == 0){
                        errorField = true;
                    }

                    if(errorField){
                        error = true;
                        setTimeout(() => {
                            this.form[field].error = true;
                        });
                    }
                }
                if(!error) {
                    this.btnType = 'load';
                    this.$store.dispatch('workers/getItem',{id:this.activeMenuItem.id}).then(()=>{
                        this.$store.dispatch('workers/workOvertime',{timeType:'end', text:this.form.text.value, workOvertimeNoComment: this.user.workOvertimeNoComment ? this.user.workOvertimeNoComment.id : false}).then(() => {
                            this.btnType = 'ok';
                            setTimeout(()=>{
                                this.$store.commit('popups/close', {name: this.popups.workOvertime.name});
                            }, this.options.delayPopupClose);
                        },()=>{});
                    });
                }
            },
            removeError(form) {
                form.error = false;
            },
        },
    }
</script>

<style scoped>
</style>
